import { render, staticRenderFns } from "./FacebookMockupPreview.vue?vue&type=template&id=704b0f0c&scoped=true&"
import script from "./FacebookMockupPreview.vue?vue&type=script&lang=js&"
export * from "./FacebookMockupPreview.vue?vue&type=script&lang=js&"
import style0 from "./FacebookMockupPreview.vue?vue&type=style&index=0&id=704b0f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b0f0c",
  null
  
)

export default component.exports